// English strings (source language): first-launch welcome.

const en = {
  welcome: 'Welcome to Gruvetto 🚴',
  intro: 'Your account is ready. Start with your profile: it calibrates the bots, zones and workouts.',
  name: 'Name',
  mass: 'Weight (kg)',
  color: 'Color',
  country: 'Country',
  countryNone: 'No flag',
  ftpHelp: 'No need to know your FTP: Gruvetto starts from your weight and works it out from your first rides.',
  go: 'Let’s go',
};
export default en;
